import { eNotificationType } from "@models";
import { icons } from "@tools";
import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.NotificationIconFilter,
    dependencies: [
    ]
})
export class NotificationIconFilter {
    constructor() {
        return ((type: string) => {
            switch (type) {
                case eNotificationType.quoteApproved:
                    return icons.approve;
                case eNotificationType.quoteRejected:
                    return icons.reject;
                default:
                    return icons.user;
            }
        }) as any;
    }
}
